<div class="tool-bar">

    <!-- icon and tab name -->
    <div class="flex items-center gap-16">

        <div class="tool-bar-left-heading">
            <i class="pi" [ngClass]="iconName" style="font-size: 23px;"></i>
            <span>{{title}}</span>
        </div>


        <div class="hidden lg:flex items-center gap-8">
            <div class="search-outer-box" *ngIf="isSearch">
                <div class="search-input-box flex items-center space-x-2">
                    <select
                        class="w-full md:w-28 bg-white text-black border border-gray-300 rounded-md px-3 py-2 focus:outline-none searchby-select"
                        [(ngModel)]="selectedFilterAttribute"
                        (change)="onFilterAttributeChange()">
                        <option value="" selected disabled>Search By</option>
                        <option *ngFor="let filter of filtersOptions" [value]="filter.value">{{ filter.header }}
                        </option>
                    </select>

                    <div class="relative">
                        <ng-container *ngIf="isDropdownFilter; else textSearchInput">
                            <select
                                class="border-none bg-transparent outline-none px-2 pr-8 py-2 text-black"
                                [(ngModel)]="searchDropdownValue"
                                [disabled]="!selectedFilterAttribute"
                                (change)="onSearchDropdownChange(searchDropdownValue)">
                                <option [ngValue]="''" disabled selected>Select</option>
                                <option *ngFor="let opt of currentFilterOption?.options" [ngValue]="opt.value">{{ opt.label }}</option>
                            </select>
                        </ng-container>
                        <ng-template #textSearchInput>
                            <input type="text" placeholder="Search" style="padding-left: 8px;"
                                (input)="onSearchChange($event)" [disabled]="!selectedFilterAttribute"
                                [(ngModel)]="searchInputValue"
                                class="border-none bg-transparent outline-none pl-8 pr-3 py-2 text-black" />
                        </ng-template>
                        <ng-container *ngIf="searchInputValue || searchDropdownValue !== '' || selectedFilterAttribute">
                            <i class="pi pi-times absolute right-7 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer" (click)="handleResetSearchFilter()"></i>
                        </ng-container>
                        <i class="pi pi-search absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500" *ngIf="!searchInputValue && searchDropdownValue === '' && !selectedFilterAttribute"></i>
                    </div>
                </div>
            </div>


            <div class="date-picker-outer-box" *ngIf="isDateFilter">
                <div class="date-picker-input-box">
                    <i class="pi pi-calendar" style="color: #9F9F9F;"></i>
                    <p-datepicker appendTo="body" class="date-picker-input" [(ngModel)]="rangeDates"
                        selectionMode="range" [readonlyInput]="true" (onSelect)="onDateChange($event)">
                        <ng-template #footer>
                            <div class="flex flex-wrap gap-2 p-3 border-t">
                                <p-button label="Today" size="small" [outlined]="true" (click)="setDateRange('today')" 
                                    styleClass="p-button-sm" />
                                <p-button label="Yesterday" size="small" [outlined]="true" (click)="setDateRange('yesterday')" 
                                    styleClass="p-button-sm" />
                                <p-button label="This Week" size="small" [outlined]="true" (click)="setDateRange('thisWeek')" 
                                    styleClass="p-button-sm" />
                                <p-button label="Last Week" size="small" [outlined]="true" (click)="setDateRange('lastWeek')" 
                                    styleClass="p-button-sm" />
                                <p-button label="This Year" size="small" [outlined]="true" (click)="setDateRange('thisYear')" 
                                    styleClass="p-button-sm" />
                                <p-button label="Last Year" size="small" [outlined]="true" (click)="setDateRange('lastYear')" 
                                    styleClass="p-button-sm" />
                            </div>
                        </ng-template>
                    </p-datepicker>

                    <div class="refresh-box" (click)="handleResetDateFilter()">
                        <div class="bg-white rounded-full h-[21px] w-[21px] flex justify-center items-center">
                            <div class="bg-green-600 flex items-center justify-center h-[17px] w-[17px] rounded-full">
                                <i class="pi pi-refresh" style="font-size: 9px;"></i>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>

    <!-- date and search -->


    <!-- actions -->
    <div class="hidden lg:flex items-center gap-4 action-items">

         <div *ngIf="selectedProducts && isBulkAction && selectedProducts.length > 0">
            <p-button label="Bulk Action" iconPos="right" icon="pi pi-chevron-down" (click)="menu.toggle($event)"
                [rounded]="true" [rounded]="true" pTooltip="Perform bulk actions" tooltipPosition="bottom" />

            <p-menu appendTo="body" #menu [model]="bulkActionItems" [popup]="true" />
        </div>

        <span *ngIf="showToggleIcon">
            <p-button (click)="toggleView()" [icon]="tableView ? 'pi pi-list' : 'pi pi-table'"
                [styleClass]="tableView ? 'p-button-outlined' : ''" [style]="{ width: '2.5rem', height: '2.5rem' }"
                [rounded]="true" [outlined]="true" [ngClass]="{ 'active': tableView }"
                pTooltip="Toggle view" tooltipPosition="bottom"></p-button>
        </span>


        <span *ngIf="isRefresh">
            <p-button icon="pi pi-sync" (onClick)="refreshData()" [rounded]="true" [outlined]="true"
                pTooltip="Refresh" tooltipPosition="bottom" />
        </span>

       

        <span *ngIf="isImport">
            <p-button (click)="handleOpenBulkAdd()" icon="pi pi-file-import" [rounded]="true" [outlined]="true"
                pTooltip="Import" tooltipPosition="bottom" />
        </span>

        <span *ngIf="isExport">
            <p-button (click)="exportPopover.toggle($event)" icon="pi pi-arrow-circle-down" [rounded]="true"
                [outlined]="true" pTooltip="Export" tooltipPosition="bottom" />
        </span>

        <span *ngIf="isDownloadForm">
            <p-button (click)="handleDownloadFormAction()" icon="pi pi-download" [rounded]="true"
                [outlined]="true" pTooltip="Download Form" tooltipPosition="bottom" />
        </span>

        <span *ngIf="isFilter" (click)="showFilterDrawer = true">
            <p-button icon="pi pi-filter" [rounded]="true" [outlined]="true"
                pTooltip="Filter" tooltipPosition="bottom" />
        </span>

        <span *ngIf="isFilterDrawer" (click)="toggleFilter.emit()">
            <p-button icon="pi pi-filter" [rounded]="true" [outlined]="true"
                pTooltip="Filter" tooltipPosition="bottom" />
        </span>

        <span *ngIf="isFindDuplicate" class="relative">
            <p-button icon="pi pi-clone" (onClick)="handleFindDuplicateAction()" [rounded]="true" [outlined]="true" 
                pTooltip="Find Duplicates" tooltipPosition="bottom" />
            <div *ngIf="duplicateCount > 0" class="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center"
                
                >
                {{ duplicateCount }}
            </div>
        </span>

        <span *ngIf="isAdd" style="margin-left: 1.5rem;">
            <p-button 
                label="Add" 
                icon="pi pi-plus" 
                (onClick)="handleAddAction()"
                styleClass="p-button-lg p-button-primary prominent-add-btn"
                 tooltipPosition="bottom" />
        </span>

    </div>

    <div class="block lg:hidden tool-bar-pop-over">
        <i (click)="op.toggle($event)" class=" pi pi-ellipsis-v" label="Share"></i>
        <p-popover #op>
            <div class="flex flex-col gap-4 w-[25rem] p-5">

                <div class="flex gap-8 flex-col">
                    <div class="search-outer-box" *ngIf="isSearch">
                        <div class="search-input-box flex items-center space-x-2">
                            <select
                                class="w-full md:w-28 bg-white text-black border border-gray-300 rounded-md px-3 py-2 focus:outline-none searchby-select"
                                [(ngModel)]="selectedFilterAttribute"
                                (change)="onFilterAttributeChange()">
                                <option value="" selected disabled>Search By</option>
                                <option *ngFor="let filter of filtersOptions" [value]="filter.value">{{ filter.header }}
                                </option>
                            </select>

                            <div class="relative">
                                <ng-container *ngIf="isDropdownFilter; else mobileTextSearchInput">
                                    <select
                                        class="border-none bg-transparent outline-none px-2 pr-8 py-2 text-black"
                                        [(ngModel)]="searchDropdownValue"
                                        [disabled]="!selectedFilterAttribute"
                                        (change)="onSearchDropdownChange(searchDropdownValue)">
                                        <option [ngValue]="''" disabled selected>Select</option>
                                        <option *ngFor="let opt of currentFilterOption?.options" [ngValue]="opt.value">{{ opt.label }}</option>
                                    </select>
                                </ng-container>
                                <ng-template #mobileTextSearchInput>
                                    <input type="text" placeholder="Search" style="padding-left: 8px;"
                                        (input)="onSearchChange($event)" [disabled]="!selectedFilterAttribute"
                                        class="border-none bg-transparent outline-none pl-8 pr-3 py-2 text-black" />
                                </ng-template>
                                <ng-container *ngIf="searchInputValue || searchDropdownValue !== '' || selectedFilterAttribute">
                                    <i class="pi pi-times absolute right-7 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer" (click)="handleResetSearchFilter()"></i>
                                </ng-container>
                                <i class="pi pi-search absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500" *ngIf="!searchInputValue && searchDropdownValue === '' && !selectedFilterAttribute"></i>
                            </div>
                        </div>
                    </div>


                    <div class="date-picker-outer-box w-full" *ngIf="isDateFilter">
                        <div class="date-picker-input-box">
                            <i class="pi pi-calendar" style="color: #9F9F9F;"></i>
                                 <p-datepicker appendTo="body" class="date-picker-input" [(ngModel)]="rangeDates"
                        selectionMode="range" [readonlyInput]="true" (onSelect)="onDateChange($event)">
                        <ng-template #footer>
                            <div class="flex flex-wrap gap-2 p-3 border-t">
                                <p-button label="Today" size="small" [outlined]="true" (click)="setDateRange('today')" 
                                    styleClass="p-button-sm" />
                                <p-button label="Yesterday" size="small" [outlined]="true" (click)="setDateRange('yesterday')" 
                                    styleClass="p-button-sm" />
                                <p-button label="This Week" size="small" [outlined]="true" (click)="setDateRange('thisWeek')" 
                                    styleClass="p-button-sm" />
                                <p-button label="Last Week" size="small" [outlined]="true" (click)="setDateRange('lastWeek')" 
                                    styleClass="p-button-sm" />
                                <p-button label="This Year" size="small" [outlined]="true" (click)="setDateRange('thisYear')" 
                                    styleClass="p-button-sm" />
                                <p-button label="Last Year" size="small" [outlined]="true" (click)="setDateRange('lastYear')" 
                                    styleClass="p-button-sm" />
                            </div>
                        </ng-template>
                    </p-datepicker>

                            <div class="refresh-box" (click)="handleRefreshDateFilter()">
                                <div
                                    class="bg-white rounded-full h-[21px] w-[21px] flex justify-center items-center max-w-10">
                                    <div
                                        class="bg-green-600 flex items-center justify-center h-[17px] w-[17px] rounded-full">
                                        <i class="pi pi-refresh" style="font-size: 9px;"></i>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

                <div class="flex items-center gap-8 action-items mt-3 flex-wrap">

                    <div *ngIf="selectedProducts && isBulkAction && selectedProducts.length > 0">
                        <p-button label="Bulk Action" iconPos='right' icon="pi pi-chevron-down"
                            (click)="menu.toggle($event)" [rounded]="true" [rounded]="true"
                            pTooltip="Perform bulk actions" tooltipPosition="bottom" />

                        <p-menu appendTo="body" #menu [model]="bulkActionItems" [popup]="true" />
                    </div>

                    <span *ngIf="showToggleIcon">
                        <p-button (click)="toggleView()" [icon]="tableView ? 'pi pi-list' : 'pi pi-table'"
                            [styleClass]="tableView ? 'p-button-outlined' : ''"
                            [style]="{ width: '2.5rem', height: '2.5rem' }" [rounded]="true" [outlined]="true"
                            [ngClass]="{ 'active': tableView }" pTooltip="Toggle view" tooltipPosition="bottom"></p-button>
                    </span>


                    <span *ngIf="isImport">
                        <p-button (click)="handleOpenBulkAdd()" icon="pi pi-file-import" [rounded]="true"
                            [outlined]="true" pTooltip="Import" tooltipPosition="bottom" />
                    </span>

                    <span *ngIf="isExport">
                        <p-button (click)="exportPopover.toggle($event)" icon="pi pi-arrow-circle-down" [rounded]="true"
                            [outlined]="true" pTooltip="Export" tooltipPosition="bottom" />
                    </span>

                    <span *ngIf="isDownloadForm">
                        <p-button (click)="handleDownloadFormAction()" icon="pi pi-download" [rounded]="true"
                            [outlined]="true" pTooltip="Download Form" tooltipPosition="bottom" />
                    </span>

                    <span *ngIf="isFilter" (click)="showFilterDrawer = true">
                        <p-button icon="pi pi-filter" [rounded]="true" [outlined]="true"
                            pTooltip="Filter" tooltipPosition="bottom" />
                    </span>

                    <span *ngIf="isFilterDrawer" (click)="toggleFilter.emit()">
                        <p-button icon="pi pi-filter" [rounded]="true" [outlined]="true"
                            pTooltip="Filter" tooltipPosition="bottom" />
                    </span>

                    <span *ngIf="isFindDuplicate" class="relative">
                        <p-button icon="pi pi-clone" (onClick)="handleFindDuplicateAction()" [rounded]="true" [outlined]="true"
                            pTooltip="Find Duplicates" tooltipPosition="bottom" />
                        <div *ngIf="duplicateCount > 0" class="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                            {{ duplicateCount }}
                        </div>
                    </span>

                    <span *ngIf="isAdd">
                        <p-button icon="pi pi-plus" (onClick)="handleAddAction()" [rounded]="true" [outlined]="true"
                            pTooltip="Add" tooltipPosition="bottom" />
                    </span>

                </div>
            </div>
        </p-popover>
    </div>



</div>

<p-drawer [(visible)]="showFilterDrawer" header="Filters" position="right" class="lead-filter-drawer">
    <div class="lead-filter-drawer-content mt-4">
        <div *ngFor="let group of filterOptions" class="p-mb-4 mb-4">
            <h5 class="mt-4 mb-4">{{ group.label }}</h5>
            <div class="p-grid">
                <div *ngFor="let item of group.items" class="p-col-12 p-md-6 flex items-center gap-3">
                    <p-checkbox [(ngModel)]="item.checked" [binary]="true"></p-checkbox>
                    <label class="p-ml-2">{{ item.label }}</label>
                </div>
            </div>
        </div>
        <div class="flex gap-4 mt-5">
            <p-button label="Clear" variant="outlined" icon="pi pi-filter-slash" severity="danger"
                (click)="clearFilters()" pTooltip="Clear all filters" tooltipPosition="bottom"></p-button>
            <p-button label="Apply" icon="pi pi-filter-fill" (click)="handleApplyFilter()"
                pTooltip="Apply filters" tooltipPosition="bottom"></p-button>
        </div>

    </div>
</p-drawer>




<p-popover #exportPopover appendTo="body" class="export-popover">
    <div class="p-4 w-96">
        <div class="flex items-center mb-2">
            <p-checkbox binary="true" [(ngModel)]="selectAllChecked" (onChange)="toggleSelectAll()" class="mr-2"
                size="small"></p-checkbox>
            <div class="font-semibold text-[12px] ml-2">Select All</div>
        </div>

        <div class="grid grid-cols-2 gap-3 mt-3">
            <div *ngFor="let item of exportItems; let i = index" class="flex items-center gap-2">
                <p-checkbox size="small" binary="true" [(ngModel)]="item.checked" class="mr-2"></p-checkbox>
                <div class="text-[12px]">{{ item.label }}</div>
            </div>
        </div>

        <div class="flex gap-4 mt-4">
            <p-button label="Cancel" variant="outlined" severity="danger" (click)="exportPopover.hide()"
                pTooltip="Cancel export" tooltipPosition="bottom" />
            <p-button label="Export" icon="pi pi-arrow-circle-down" (click)="saveSelection(); exportPopover.hide()"
                pTooltip="Export selected items" tooltipPosition="bottom" />
        </div>
    </div>

</p-popover>